import React from 'react';

import Grid from './grid.svg?react';

function FarmbotGridIcon() {
  return <Grid width={18} />;
}

export default FarmbotGridIcon;
